import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import AuthPage from "@/pages/AuthPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import HomePage from "@/pages/HomePage";
import LandingPage from "@/pages/LandingPage";
import QuestoesPage from "@/pages/QuestoesPage";
import SimuladosPage from "@/pages/SimuladosPage";
import DesempenhoPage from "@/pages/DesempenhoPage";
import PremiumPage from "@/pages/PremiumPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import PaymentCancelPage from "@/pages/PaymentCancelPage";
import AdminPage from "@/pages/AdminPage";
import ErrosPage from "@/pages/ErrosPage";
import IncidenciaPage from "@/pages/IncidenciaPage";
import MapasMentaisPage from "@/pages/MapasMentaisPage";
import MateriaisPage from "@/pages/MateriaisPage";
import PlanoPage from "@/pages/PlanoPage";
import SupportPage from "@/pages/SupportPage";
import { Loader2 } from "lucide-react";

function Protected({ children }) {
  const { authed, user } = useAuth();
  const token = localStorage.getItem("vc_token");
  if (token && user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-950">
        <Loader2 className="h-8 w-8 animate-spin text-emerald-400" />
      </div>
    );
  }
  if (!authed) return <Navigate to="/login" replace />;
  return (
    <div className="min-h-screen bg-slate-950">
      <Navbar />
      {children}
    </div>
  );
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<AuthPage />} />
      <Route path="/esqueci-senha" element={<ForgotPasswordPage />} />
      <Route path="/redefinir-senha" element={<ResetPasswordPage />} />
      <Route path="/" element={<LandingPage />} />
<Route path="/inicio" element={<Protected><HomePage /></Protected>} />
      <Route path="/questoes" element={<Protected><QuestoesPage /></Protected>} />
      <Route path="/simulados" element={<Protected><SimuladosPage /></Protected>} />
      <Route path="/desempenho" element={<Protected><DesempenhoPage /></Protected>} />
      <Route path="/premium" element={<Protected><PremiumPage /></Protected>} />
      <Route path="/admin" element={<Protected><AdminPage /></Protected>} />
      <Route path="/erros" element={<Protected><ErrosPage /></Protected>} />
      <Route path="/incidencia" element={<Protected><IncidenciaPage /></Protected>} />
      <Route path="/mapas-mentais" element={<Protected><MapasMentaisPage /></Protected>} />
      <Route path="/materiais" element={<Protected><MateriaisPage /></Protected>} />
      <Route path="/plano" element={<Protected><PlanoPage /></Protected>} />
      <Route path="/suporte" element={<Protected><SupportPage /></Protected>} />
      <Route path="/payment/success" element={<PaymentSuccessPage />} />
      <Route path="/payment/cancel" element={<PaymentCancelPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-center" theme="dark" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}
